module.exports = __webpack_public_path__ + "img/ul.b05589fa.svg";